export var filterDiscontinuedShade = function filterDiscontinuedShade(_ref) {
  var hexColors = _ref.hexColors,
    imageUrl = _ref.imageUrl;
  return hexColors && hexColors.length > 0 || Boolean(imageUrl);
};
//# sourceMappingURL=filterDiscontinuedShade.js.map